var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
import { isNumber, } from "../utilities/wsi4_typeguards";
let TubeLengthElement = class TubeLengthElement extends Vue {
    constructor() {
        super(...arguments);
        this.value = 0.;
    }
    onChange() {
        return this.value;
    }
    initialize() {
        this.value = this.dimX;
    }
    get invalid() {
        return !isNumber(this.value) || this.value > this.maximalDimX || this.value < this.minimalDimX;
    }
    created() {
        this.initialize();
    }
    dimXChanged() {
        this.initialize();
    }
    onValueChanged() {
        this.onChange();
    }
};
__decorate([
    Prop({ required: true })
], TubeLengthElement.prototype, "dimX", void 0);
__decorate([
    Prop({ required: true })
], TubeLengthElement.prototype, "disabled", void 0);
__decorate([
    Prop({ required: true })
], TubeLengthElement.prototype, "maximalDimX", void 0);
__decorate([
    Prop({ required: true })
], TubeLengthElement.prototype, "minimalDimX", void 0);
__decorate([
    Emit()
], TubeLengthElement.prototype, "onChange", null);
__decorate([
    Inject()
], TubeLengthElement.prototype, "i18n", void 0);
__decorate([
    Watch("dimX")
], TubeLengthElement.prototype, "dimXChanged", null);
__decorate([
    Watch("value")
], TubeLengthElement.prototype, "onValueChanged", null);
TubeLengthElement = __decorate([
    Component({
        components: {},
        name: "TubeLengthElement",
    })
], TubeLengthElement);
export default TubeLengthElement;
